import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { environment } from '../../../environments/environment';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete/ngx-google-places-autocomplete.directive';
import { Router } from '@angular/router';

import { PropertyService } from '../../services/property.service';
import { AdminLandingComponent } from '../../admin/admin-landing/admin-landing.component';
import { AuthService } from '../../services/auth.service';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@Component({
  selector: 'app-property-view',
  templateUrl: './property-view.component.html',
  styleUrls: ['./property-view.component.scss']
})
export class PropertyViewComponent implements OnInit {
  @Input()
  property;

  loading: boolean = true;

  private backupProperty;
    
  fullAddress: string = "";

  @Input()
  editable: boolean = false;

  @Input()
  attributes;

  @Input()
  editMode: boolean = false;
  
  @Output()
  onCancel = new EventEmitter<void>();
    
  selectedFile: File;
    
  private newFileSelected = false;

  balanceDue: number = 0;
    

  constructor(private propertyService: PropertyService,
              private alc: AdminLandingComponent,
              private authService: AuthService,
              private router: Router) { }

    
    
  ngOnInit() {
      if (typeof this.property.addressLine1 !== 'undefined' && this.fullAddress == ""){
        this.fullAddress = this.property.addressLine1 + ", " + this.property.city + ", " + this.property.state + ", " + this.property.zipCode;
      }

      // Automatically enable edit mode when the property does not have an id
      if (this.property.id == null || this.property.id == undefined) {
        this.editMode = true;
      }

      console.log("prop init");
      // Don't wait for image - show content immediately
      this.loading = false;

      // Only fetch invoice summary if:
      // 1. Property has an ID
      // 2. User is authenticated and is an admin
      // 3. We're on an authenticated page (not a public page)
      const currentPath = this.router.url.split('?')[0];
      const isPublicPage = currentPath === '' || currentPath === '/';
      const isAuthenticatedPage = currentPath.includes('/admin-landing') || 
                                  currentPath.includes('/super-admin') || 
                                  currentPath.includes('/lessee-landing');

      if (this.property.id && 
          this.authService.isAuthenticated() && 
          this.authService.isAdmin() && 
          isAuthenticatedPage && 
          !isPublicPage) {
        this.propertyService.getInvoiceSummary(this.property).then((summary: any) => {
          if (summary && summary.balanceDue) {
            this.balanceDue = summary.balanceDue;
          }
        }).catch((error) => {
          // Silently fail if not authorized or other error
          // Don't log to console to avoid noise
        });
      }
  }

  getAttributeById(attributeId) {
      return this.attributes.find(attribute => {
        return attribute.id == attributeId;
      });
  }

  /**
   * Availability is derived from lease state (the single source of truth).
   * Prefer the API-provided `available` flag, then fall back to the leases
   * array, and finally the legacy `status` string for older payloads.
   */
  get isAvailable(): boolean {
    if (!this.property) {
      return false;
    }
    if (this.property.available !== undefined && this.property.available !== null) {
      return !!this.property.available;
    }
    if (Array.isArray(this.property.leases)) {
      const hasActiveLease = this.property.leases.some(
        lease => lease && (lease.status === 'ACTIVE' || lease.status == null)
      );
      return !hasActiveLease;
    }
    return this.property.status === 'FOR_LEASE';
  }

  enterEditMode(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.backupProperty = JSON.parse(JSON.stringify(this.property));
    this.editMode = true;
  }

  cancelAction(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    // If this is a newly added property without a backup, simply notify the
    // parent component so it can remove it from the list
    if(!this.property.id && !this.backupProperty) {
      if(this.onCancel) {
        this.onCancel.emit();
      }
      return;
    }

    // Otherwise restore the previous state and exit edit mode
    this.property = this.backupProperty;
    this.editMode = false;
    this.newFileSelected = false;

    if(this.onCancel) {
      this.onCancel.emit();
    }
  }

  saveAction(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.loading = true;
    if(this.property.id) {
      this.propertyService.updateProperty(this.property).then((res) => {
        if(this.selectedFile !== undefined){
            this.propertyService.uploadCoverImage(this.property.id,this.selectedFile).then((msg) => {});
        }
        this.editMode = false;
        this.newFileSelected = false;
        this.alc.updateDataSave();
        this.loading=false;
      });
    } else {
      this.propertyService.createProperty(this.property).then((res) => {
        this.editMode = false;
        this.newFileSelected = false;
        this.alc.updateDataSave();
        this.loading=false;
      });
    }

    
  }
  deleteAction(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    if (!confirm(`Are you sure you want to delete ${this.property.addressLine1}?`)) {
      return;
    }
    this.loading=true;
    this.propertyService.deleteProperty(this.property).then((res)=>{
      this.alc.updateDataDelete();
    });
    
  }
    
  updatePropMainPicAction(event){
    this.newFileSelected = true;
      
    this.selectedFile = event.target.files[0];
      
    var reader = new FileReader();

    reader.readAsDataURL(this.selectedFile); // read file as data url

    reader.onload = (event) => { // called once readAsDataURL is completed
        this.property.coverImage = reader.result;
    }
     
  }
    
  public handleAddressChange(address) {
        console.log(address);
        console.log(this.property);
        let street = "";
        let streetNumber = "";
        let line2 = "";
      
        for (var i = 0, len = address.address_components.length; i < len; i++) {
            if(address.address_components[i].types.includes("administrative_area_level_1")){
                this.property.state = address.address_components[i].short_name;
            }
            if(address.address_components[i].types.includes("country")){
                //this.property.state = e.short_name;
            }
            if(address.address_components[i].types.includes("street_number")){
                 console.log(address.address_components[i].short_name);
                streetNumber = address.address_components[i].short_name;
            }
            if(address.address_components[i].types.includes("route")){
                street = address.address_components[i].short_name;
            }
            if(address.address_components[i].types.includes("subpremise")){
                line2 = address.address_components[i].short_name;
            }
            if(address.address_components[i].types.includes("locality")){
                this.property.city = address.address_components[i].short_name;
            }
            if(address.address_components[i].types.includes("postal_code")){
                this.property.zipCode = address.address_components[i].short_name;
            } 
        };
        this.property.addressLine1 = (streetNumber + " " + street).trim();
        this.property.addressLine2 = line2 ? line2 : undefined;
    }

  getImageUrl(path: string) {
    if (!path) {
      return '';
    }
    
    // If it's already a full URL (http/https or data URI), use it directly
    if (path.startsWith('http') || path.startsWith('data:')) {
      // Only convert S3 URLs to API paths if we have a property ID
      if (path.includes('amazonaws.com') && this.property && this.property.id) {
        const fileName = path.substring(path.lastIndexOf('/') + 1);
        return `${environment.apiBaseUrl}/v1/public/properties/${this.property.id}/coverImage/${fileName}`;
      }
      // Otherwise, use the S3 URL directly
      return path;
    }
    
    // If it's a relative path, add the API base URL
    return environment.apiBaseUrl + path;
  }

  onImageLoad() {
    this.loading = false;
  }

  onImageError() {
    this.loading = false;
  }

}
